import { render, staticRenderFns } from "./wec.vue?vue&type=template&id=969d24de&scoped=true&"
import script from "./wec.vue?vue&type=script&lang=js&"
export * from "./wec.vue?vue&type=script&lang=js&"
import style0 from "./wec.vue?vue&type=style&index=0&id=969d24de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969d24de",
  null
  
)

export default component.exports